import cataloging from './cataloging';

const navigation = [...cataloging];

export default navigation;
